export const MIN_ASSESSMENTS = 5;

export function createEmptyAssessments(count = MIN_ASSESSMENTS) {
  return Array.from({ length: count }, () => ({ Assessment: '', Yoe: '' }));
}

export function createEmptyAssessmentRows(count = MIN_ASSESSMENTS) {
  return Array.from({ length: count }, () => ({ assessment: '', yoe: '' }));
}

export function padAssessments(assessments = [], minCount = MIN_ASSESSMENTS) {
  const rows = (assessments || []).map((item) => ({
    assessment: item?.assessment || item?.Assessment || '',
    yoe: item?.yoe || item?.Yoe || '',
  }));

  while (rows.length < minCount) {
    rows.push({ assessment: '', yoe: '' });
  }

  return rows;
}

export function validateAssessmentsInput(assessments = [], minCount = MIN_ASSESSMENTS) {
  const validRows = (assessments || []).filter((item) => {
    const assessment = String(item?.assessment || item?.Assessment || '').trim();
    const yoe = String(item?.yoe || item?.Yoe || '').trim();
    return assessment && yoe;
  });

  if (validRows.length < minCount) {
    return {
      ok: false,
      message: `Minimum ${minCount} assessments are required.`,
      assessments: validRows.map((item) => ({
        assessment: String(item.assessment || item.Assessment || '').trim(),
        yoe: String(item.yoe || item.Yoe || '').trim(),
      })),
    };
  }

  return {
    ok: true,
    assessments: validRows.map((item) => ({
      assessment: String(item.assessment || item.Assessment || '').trim(),
      yoe: String(item.yoe || item.Yoe || '').trim(),
    })),
  };
}

const REQUIREMENT_EDIT_SKIP_KEYS = new Set([
  'userUploadSettings',
  'userDetails',
  'uploadedCandidates',
  'uploadedCandidatesCount',
  'activeCandidatesCount',
  'noactionCandidates',
  'noactionCandidatesCount',
  'actionTakenCandidatesCount',
  'rejectedCandidatesCount',
  'workflow',
  'claimedBy',
  'currentClaimedBy',
  'creatorName',
  'creatorUserType',
  'requirementSource',
  '__v',
]);

export function appendRequirementFormData(formData, payload = {}, jdFile) {
  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (REQUIREMENT_EDIT_SKIP_KEYS.has(key)) return;
    if (key === 'assessments') {
      formData.append('assessments', JSON.stringify(value));
      return;
    }
    if (key === 'assignedMembers') {
      let members = value;
      if (typeof members === 'string') {
        try {
          members = JSON.parse(members);
        } catch (error) {
          members = [];
        }
      }
      if (!Array.isArray(members)) {
        members = [];
      }
      formData.append('assignedMembers', JSON.stringify(members));
      return;
    }
    if (Array.isArray(value) || (typeof value === 'object' && typeof value.append !== 'function')) {
      formData.append(key, JSON.stringify(value));
      return;
    }
    formData.append(key, value);
  });

  if (jdFile) {
    formData.append('jdPdf', jdFile);
  }
}
